import { Injectable } from "@angular/core";
import { ApiService } from "@core/services/api.service";
import { ApiServiceHolder } from "@core/utils/api-service-holder";
import { Observable } from "rxjs";
import { IBidResponse } from "src/app/article/interfaces/bid-response.interface";
import { BidDto, UserAutoRebid } from "src/app/articles-manager/interfaces/auction.interface";
import { AuctionPriceInfo, DonationDto, EventNotification, MemoraEndDate, MemoraEventAuction, MemoraEventAuctionView, MemoraEventSaveDto, MemoraEventSummary, MemoraEventView, NotificationStatusDto } from "../interfaces/event.interface";

@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor(private _api: ApiService) {}

  getAll(): Observable<MemoraEventView[]> {
    return this._api.request(ApiServiceHolder.memorabidevent.getAll());
  }

  getByPk(idEvent: number): Observable<MemoraEventAuction> {
    return this._api.request(ApiServiceHolder.memorabidevent.getByPk(idEvent));
  }

  getBySlug(slug: string): Observable<MemoraEventAuction> {
    return this._api.request(ApiServiceHolder.memorabidevent.getBySlug(slug));
  }

  getAllViewByPk(idEvent: number, idLanguage: number): Observable<MemoraEventAuctionView> {
    return this._api.request(ApiServiceHolder.memorabidevent.getAllViewByPk(idEvent, idLanguage));
  }

  getAllViewBySlug(slug: string, idlanguage: number): Observable<MemoraEventAuctionView> {
    return this._api.request(ApiServiceHolder.memorabidevent.getAllViewBySlug(slug, idlanguage));
  }

  saveEvent(memoraEventSaveDto: MemoraEventSaveDto) {
    return this._api.request(ApiServiceHolder.memorabidevent.save(memoraEventSaveDto));
  }

  saveDonation(donation: DonationDto) {
    return this._api.request(ApiServiceHolder.donation.save(donation));
  }

  getSummary(idEvent: number, idLanguage: number): Observable<MemoraEventSummary[]> {
    return this._api.request(ApiServiceHolder.memorabidevent.getSummary(idEvent, idLanguage));
  }

  getEventNotification(idEvent: number, idLanguage: number): Observable<EventNotification[]> {
    return this._api.request(ApiServiceHolder.memorabidevent.getEventNotification(idEvent, idLanguage));
  }

  getTotalAmount(idEvent: number): Observable<number> {
    return this._api.request(ApiServiceHolder.memorabidevent.getTotalAmount(idEvent));
  }

  getEventDateEnd(idEvent: number): Observable<MemoraEndDate> {
    return this._api.request(ApiServiceHolder.memorabidevent.getEventDateEnd(idEvent));
  }

  bid(bid: BidDto): Observable<IBidResponse> {
    return this._api.request(ApiServiceHolder.memorabidevent.bid(bid));
  }


  autobid(bid: UserAutoRebid): Observable<UserAutoRebid> {
    return this._api.request(ApiServiceHolder.memorabidevent.autoRebid(bid));
  }

  getAuctionPriceInfo(idAuction: number): Observable<AuctionPriceInfo> {
    return this._api.request(ApiServiceHolder.auction.getAuctionPriceInfo(idAuction));
  }

  setNotificationStatus(status: NotificationStatusDto) {
    return this._api.request(ApiServiceHolder.memorabidevent.setNotificationStatus(status));
  }

}
